// RUNN — Firebase config + environment flags ONLY (no SDK imports).
// Importing `backendLive` from here never drags the Firebase SDK into a bundle,
// so the marketing landing stays lean; the SDK loads only where it's used.
const cfg = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

export const firebaseConfig = cfg;
/** True when real Firebase web config is present in .env */
export const isConfigured = Boolean(cfg.apiKey && cfg.projectId);
export const useEmulators = String(import.meta.env.VITE_USE_EMULATORS) === 'true';
/** Backend is reachable when real config exists OR we're pointed at emulators. */
export const backendLive = isConfigured || useEmulators;
